import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, redMui } from "@ryde/theme";

export const AccessDeniedMessageWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "access-denied-message-wrapper",
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 48px 24px;
  text-align: center;

  .access-denied-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 24px;
    color: ${redMui._500};
    opacity: 0.8;
  }

  .access-denied-title {
    font-size: 24px;
    font-weight: 600;
    color: ${greyMui._800};
    margin: 0;
    line-height: 1.4;
  }
`;
